import * as constants from '../constants'
import { move } from 'ramda'
import { normalize } from '@engine/dependencies'
import {
  changeBarColors,
  getChartData,
  getFpData,
  getFPBarChartData
} from '@engine/utils/barChartHelper'
import {
  THEME_COLOR_CODES,
  BAR_CHART_COLOR_CODES,
  DONUT_CHART_COLOR_CODES
} from '@engine/utils/colorCodes'
import {
  PROPERTY_FIELDS_RENT,
  PROPERTY_ALL_FIELDS_RENT_T5,
  PROPERTY_ALL_FIELDS_RENT,
  PROPERTY_FIELDS_SALES,
  SUMMARY_TABLE_COLUMNS_RENT,
  SUMMARY_TABLE_COLUMNS_RENT_T6,
  SUMMARY_TABLE_COLUMNS_SALES,
  SUMMARY_TABLE_COLUMNS_SALES_S2,
  SALES_COMPARABLES,
  SUMMARY_TABLE_COLUMNS_SH,
  PROPERTY_FIELDS_SH,
  SH_COMPARABLES,
  UNITMIX_TABLE_COLUMNS_T1,
  UNITMIX_TABLE_COLUMNS_SH1,
  FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
  RENT_COMPARABLES,
  UNITMIX_TABLE_COLUMNS_ALL_T1,
  UNITMIX_TABLE_COLUMNS_ALL
} from '@engine/dependencies/constants'

let tempThemeColorObj = null
let tempDonutThemeColorObj = null
const MAX_NOTES_COUNT_T1 = 1300
const MAX_NOTES_COUNT_SH1 = 1300
const MAX_AMENITIES_COUNT_T2 = 40
const MAX_NOTES_COUNT_T3 = 830
const LARGE_UNITMIX_COUNT_T4 = 15
const MAX_UNITMIX_COUNT_T4 = 24
const MAX_UNITMIX_COUNT_T3 = 12
const UNITMIX_COUNT_T1 = 28
const UNITMIX_COUNT_SH1 = 28

const templates = [
  {
    id: 1,
    templateName: 'T1',
    notSelectedImage: '/images/t1thumb.svg',
    selectedImage: '/images/t1thumbSelected.svg',
    previewImage: '/images/t1.svg'
  },
  {
    id: 2,
    templateName: 'T2',
    notSelectedImage: '/images/t2thumb.svg',
    selectedImage: '/images/t2thumbSelected.svg',
    previewImage: '/images/t2.svg'
  },
  {
    id: 3,
    templateName: 'T3',
    notSelectedImage: '/images/t3thumb.svg',
    selectedImage: '/images/t3thumbSelected.svg',
    previewImage: '/images/t3.svg'
  },
  {
    id: 4,
    templateName: 'T4',
    notSelectedImage: '/images/t4thumb.svg',
    selectedImage: '/images/t4thumbSelected.svg',
    previewImage: '/images/t4.svg'
  },
  {
    id: 5,
    templateName: 'T5',
    notSelectedImage: '/images/t5thumb.svg',
    selectedImage: '/images/t5thumbSelected.svg',
    previewImage: '/images/t5.svg'
  },
  {
    id: 6,
    templateName: 'T6',
    notSelectedImage: '/images/t6thumb.svg',
    selectedImage: '/images/t6thumbSelected.svg',
    previewImage: '/images/t6.svg'
  }
]

const salesTemplates = [
  {
    id: 1,
    templateName: 'S1',
    notSelectedImage: '/images/s1thumb.svg',
    selectedImage: '/images/s1thumbSelected.svg',
    previewImage: '/images/s1.svg'
  },
  {
    id: 2,
    templateName: 'S2',
    notSelectedImage: '/images/s2thumb.svg',
    selectedImage: '/images/s2thumbSelected.svg',
    previewImage: '/images/s2.svg'
  }
]

const studentHousingTemplates = [
  {
    id: 1,
    templateName: 'SH1',
    notSelectedImage: '/images/sh1thumb.svg',
    selectedImage: '/images/sh1thumbSelected.svg',
    previewImage: '/images/sh1.svg'
  }
]

const dataLimits = {
  T1: {
    sourceNotesCount: 43,
    notesCount: 426,
    unitMixCount: 19,
    amenitiesCount: 16,
    templateName: 'rentComps',
    key: 'T1'
  },
  T2: {
    sourceNotesCount: 43,
    notesCount: 1009,
    unitMixCount: 28,
    amenitiesCount: 22,
    templateName: 'rentCompsT2',
    key: 'T2'
  },
  T3: {
    sourceNotesCount: 43,
    notesCount: 362,
    unitMixCount: 11,
    amenitiesCount: 0,
    templateName: 'rentCompsT3',
    key: 'T3'
  },
  T4: {
    sourceNotesCount: 43,
    notesCount: 0,
    unitMixCount: 7,
    amenitiesCount: 9,
    templateName: 'rentCompsT4',
    key: 'T4'
  },
  T5: {
    sourceNotesCount: 43,
    notesCount: 0,
    unitMixCount: 0,
    amenitiesCount: 0,
    templateName: 'rentCompsT5',
    key: 'T5'
  },
  T6: {
    sourceNotesCount: 43,
    notesCount: 0,
    unitMixCount: 0,
    amenitiesCount: 0,
    templateName: 'rentCompsT6',
    key: 'T6'
  },
  S1: {
    sourceNotesCount: 65,
    notesCount: 0,
    amenitiesCount: 0,
    unitMixCount: 7,
    templateName: 'salesComps',
    key: 'S1'
  },
  S2: {
    sourceNotesCount: 0,
    notesCount: 0,
    unitMixCount: 0,
    amenitiesCount: 0,
    templateName: 'salesCompsT2',
    key: 'S2'
  },
  SH1: {
    sourceNotesCount: 43,
    notesCount: 426,
    unitMixCount: 19,
    amenitiesCount: 16,
    templateName: 'studentHousingComps',
    key: 'SH1'
  }
}

const setDataLimits = templateType => {
  const templateDataLimits = new Map()
    .set('T1', { ...dataLimits.T1 })
    .set('T2', { ...dataLimits.T2 })
    .set('T3', { ...dataLimits.T3 })
    .set('T4', { ...dataLimits.T4 })
    .set('T5', { ...dataLimits.T5 })
    .set('T6', { ...dataLimits.T6 })
    .set('S1', { ...dataLimits.S1 })
    .set('S2', { ...dataLimits.S2 })
    .set('SH1', { ...dataLimits.SH1 })

  return templateDataLimits.get(templateType || undefined)
}

const getFields = (templateType, currentFields) => {
  let applicableFields, maxFields
  switch (templateType) {
    case 'T5':
      applicableFields = PROPERTY_ALL_FIELDS_RENT_T5
      maxFields = 9
      break
    case 'S1':
    case 'S2':
      return currentFields
    default:
      applicableFields = PROPERTY_ALL_FIELDS_RENT
      maxFields = 6
  }

  const applicableFieldsKeys = applicableFields.map(prop => prop.key)
  const currentApplicableFields = currentFields.filter(field =>
    applicableFieldsKeys.includes(field.key)
  )
  const currentApplicableFieldsLength = currentApplicableFields.length
  for (let i = 0; i < maxFields - currentApplicableFieldsLength; i += 1) {
    currentApplicableFields.push({ key: 'NA', value: 'NA' })
  }

  return currentApplicableFields
}

const getunitMixTableFields = (templateType, currentFields) => {
  let applicableFields, maxFields
  switch (templateType) {
    case 'T1':
      applicableFields = UNITMIX_TABLE_COLUMNS_ALL_T1
      maxFields = 7
      break
    default:
      applicableFields = UNITMIX_TABLE_COLUMNS_ALL
      maxFields = 5
  }

  const applicableFieldsKeys = applicableFields.map(prop => prop.key)
  const currentApplicableFields = currentFields.filter(
    (field, index) =>
      index < maxFields && applicableFieldsKeys.includes(field.key)
  )
  const currentApplicableFieldsLength = currentApplicableFields.length
  for (let i = 0; i < maxFields - currentApplicableFieldsLength; i += 1) {
    currentApplicableFields.push({ key: 'NA', value: 'NA' })
  }

  return currentApplicableFields
}

const getSummaryColumns = (templateType, templateName) => {
  let summaryColumns
  switch (templateType) {
    case 'T6':
      summaryColumns = SUMMARY_TABLE_COLUMNS_RENT_T6
      break
    case 'S2':
      summaryColumns = SUMMARY_TABLE_COLUMNS_SALES_S2
      break
    case 'SH1':
      summaryColumns = SUMMARY_TABLE_COLUMNS_SH
      break
    default:
      summaryColumns = templateName.includes(SALES_COMPARABLES)
        ? SUMMARY_TABLE_COLUMNS_SALES
        : SUMMARY_TABLE_COLUMNS_RENT
  }

  return summaryColumns
}

const getBarChartLayoutOptions = barChartData => {
  const layoutOptions = barChartData.map(pageObj => {
    const title = pageObj.pageTitle

    return {
      pageTitle: title,
      layout: 1
    }
  })

  return layoutOptions
}

const getFloorPlanBarChartLayoutOptions = (fpSummaryData, fpBarChartData) => {
  const fpBaChartLayoutOptions = []
  if (fpSummaryData) {
    fpSummaryData.forEach(summaryObj => {
      fpBaChartLayoutOptions.push({
        pageTitle: summaryObj.pageTitle,
        layout: 1
      })
      fpBarChartData.forEach(fpBarData => {
        if (fpBarData.type === summaryObj.type) {
          fpBaChartLayoutOptions.push({
            pageTitle: fpBarData.pageTitle,
            layout: 1
          })
        }
      })
    })
  }

  return fpBaChartLayoutOptions
}

const mergeSavedYaxisConfig = (regeneratedCharts, savedCharts) => {
  if (!regeneratedCharts?.length || !savedCharts?.length) {
    return regeneratedCharts
  }

  const savedConfigByPageTitle = savedCharts.reduce((acc, chart) => {
    if (chart?.pageTitle && chart?.chartData?.yaxisConfig) {
      acc[chart.pageTitle] = chart.chartData.yaxisConfig
    }

    return acc
  }, {})

  return regeneratedCharts.map(chart => {
    const savedYaxisConfig = savedConfigByPageTitle[chart.pageTitle]
    if (!savedYaxisConfig) {
      return chart
    }

    return {
      ...chart,
      chartData: {
        ...chart.chartData,
        yaxisConfig: { ...savedYaxisConfig }
      }
    }
  })
}

const filterLayoutOptionsAfterPropertyDelete = (
  barChartData,
  currentLayoutOptions
) => {
  const updatedLayoutOptions = currentLayoutOptions.filter(layoutObj =>
    barChartData.find(dataObj => dataObj.pageTitle === layoutObj.pageTitle)
  )

  return updatedLayoutOptions
}

const filterFpLayoutOptionsAfterPropertyDelete = (
  fpSummaryData,
  fpBarChartData,
  currentLayoutOptions
) => {
  const pagetitles = []
  if (fpSummaryData && fpBarChartData) {
    fpSummaryData.forEach(data => pagetitles.push(data.pageTitle))
    fpBarChartData.forEach(data => pagetitles.push(data.pageTitle))
  }
  const updatedLayoutOptions =
    currentLayoutOptions &&
    currentLayoutOptions.filter(layoutObj =>
      pagetitles.find(pageTitle => pageTitle === layoutObj.pageTitle)
    )

  return updatedLayoutOptions
}

const getUpdatedThemeColors = (themeColorChoosen, previousStateColor) => {
  const themeColorKeyobj = Object.keys(themeColorChoosen)
  const [colorKey] = themeColorKeyobj
  const coloraction = themeColorChoosen.action
  const updatedColors = {}
  if (colorKey === 'globalColor') {
    if (coloraction === false) {
      // const colorWithOpacity = themeColorChoosen[colorKey].replace(/1\)/, '0.2)')
      updatedColors.globalColor = tempThemeColorObj.globalColor
      updatedColors.summaryRowBackgroundColor =
        tempThemeColorObj.summaryRowBackgroundColor
      updatedColors.summarySubjectBackgroundColor =
        tempThemeColorObj.summarySubjectBackgroundColor
      updatedColors.summarySubjectBorderColor =
        tempThemeColorObj.summarySubjectBorderColor
      updatedColors.summarySubjectTextColor =
        tempThemeColorObj.summarySubjectTextColor
      updatedColors.summaryComparableTextColor =
        tempThemeColorObj.summaryComparableTextColor
      updatedColors.summaryComparableBorderColor =
        tempThemeColorObj.summaryComparableBorderColor
      updatedColors.summaryComparableBackgroundColor =
        tempThemeColorObj.summaryComparableBackgroundColor

      updatedColors.subjectPropertyNameColor =
        tempThemeColorObj.subjectPropertyNameColor
      updatedColors.subjectSectionHeadingColor =
        tempThemeColorObj.subjectSectionHeadingColor
      updatedColors.subjectTextbulletColor =
        tempThemeColorObj.subjectTextbulletColor
      updatedColors.subjectMarkerBackgroundColor =
        tempThemeColorObj.subjectMarkerBackgroundColor
      updatedColors.subjectMarkerBorderColor =
        tempThemeColorObj.subjectMarkerBorderColor
      updatedColors.subjectMarkerTextColor =
        tempThemeColorObj.subjectMarkerTextColor

      updatedColors.comparablePropertyNameColor =
        tempThemeColorObj.comparablePropertyNameColor
      updatedColors.comparableSectionHeadingColor =
        tempThemeColorObj.comparableSectionHeadingColor
      updatedColors.comparableTextbulletColor =
        tempThemeColorObj.comparableTextbulletColor
      updatedColors.comparableMarkerTextColor =
        tempThemeColorObj.comparableMarkerTextColor
      updatedColors.comparableMarkerBorderColor =
        tempThemeColorObj.comparableMarkerBorderColor
      updatedColors.comparableMarkerBackgroundColor =
        tempThemeColorObj.comparableMarkerBackgroundColor
      tempThemeColorObj = null
    } else if (coloraction === true) {
      const colorWithOpacity = themeColorChoosen[colorKey].replace(
        /1\)/,
        '0.2)'
      )
      updatedColors.summaryRowBackgroundColor = colorWithOpacity
      updatedColors.summarySubjectBackgroundColor = themeColorChoosen[colorKey]
      updatedColors.summarySubjectBorderColor = themeColorChoosen[colorKey]
      updatedColors.summarySubjectTextColor =
        THEME_COLOR_CODES.summarySubjectTextColor
      updatedColors.summaryComparableTextColor = themeColorChoosen[colorKey]
      updatedColors.summaryComparableBorderColor = themeColorChoosen[colorKey]
      updatedColors.summaryComparableBackgroundColor =
        THEME_COLOR_CODES.summaryComparableBackgroundColor

      updatedColors.subjectPropertyNameColor = themeColorChoosen[colorKey]
      updatedColors.subjectSectionHeadingColor = themeColorChoosen[colorKey]
      updatedColors.subjectTextbulletColor = themeColorChoosen[colorKey]
      updatedColors.subjectMarkerBackgroundColor = themeColorChoosen[colorKey]
      updatedColors.subjectMarkerBorderColor = themeColorChoosen[colorKey]
      updatedColors.subjectMarkerTextColor =
        THEME_COLOR_CODES.subjectMarkerTextColor

      updatedColors.comparablePropertyNameColor = themeColorChoosen[colorKey]
      updatedColors.comparableSectionHeadingColor = themeColorChoosen[colorKey]
      updatedColors.comparableTextbulletColor = themeColorChoosen[colorKey]
      updatedColors.comparableMarkerTextColor = themeColorChoosen[colorKey]
      updatedColors.comparableMarkerBorderColor = themeColorChoosen[colorKey]
      updatedColors.comparableMarkerBackgroundColor =
        THEME_COLOR_CODES.comparableMarkerBackgroundColor
      tempThemeColorObj = null
    } else {
      if (tempThemeColorObj === null) {
        tempThemeColorObj = { ...previousStateColor }
      }
      const colorWithOpacity = themeColorChoosen[colorKey].replace(
        /1\)/,
        '0.2)'
      )
      updatedColors.summaryRowBackgroundColor = colorWithOpacity
      updatedColors.summarySubjectBackgroundColor = themeColorChoosen[colorKey]
      updatedColors.summarySubjectBorderColor = themeColorChoosen[colorKey]
      updatedColors.summarySubjectTextColor =
        THEME_COLOR_CODES.summarySubjectTextColor
      updatedColors.summaryComparableTextColor = themeColorChoosen[colorKey]
      updatedColors.summaryComparableBorderColor = themeColorChoosen[colorKey]
      updatedColors.summaryComparableBackgroundColor =
        THEME_COLOR_CODES.summaryComparableBackgroundColor

      updatedColors.subjectPropertyNameColor = themeColorChoosen[colorKey]
      updatedColors.subjectSectionHeadingColor = themeColorChoosen[colorKey]
      updatedColors.subjectTextbulletColor = themeColorChoosen[colorKey]
      updatedColors.subjectMarkerBackgroundColor = themeColorChoosen[colorKey]
      updatedColors.subjectMarkerBorderColor = themeColorChoosen[colorKey]
      updatedColors.subjectMarkerTextColor =
        THEME_COLOR_CODES.subjectMarkerTextColor

      updatedColors.comparablePropertyNameColor = themeColorChoosen[colorKey]
      updatedColors.comparableSectionHeadingColor = themeColorChoosen[colorKey]
      updatedColors.comparableTextbulletColor = themeColorChoosen[colorKey]
      updatedColors.comparableMarkerTextColor = themeColorChoosen[colorKey]
      updatedColors.comparableMarkerBorderColor = themeColorChoosen[colorKey]
      updatedColors.comparableMarkerBackgroundColor =
        THEME_COLOR_CODES.comparableMarkerBackgroundColor
    }
  }

  return updatedColors
}

const getAllunitTypes = compsData => {
  const AllUnitTypes = []
  compsData.forEach(obj => {
    if (obj.chartData) {
      AllUnitTypes.push(...Object.keys(obj.chartData))
    }
  })
  const unitTypes = [
    ...new Set(
      AllUnitTypes.map(type =>
        type
          .trim()
          .replace(/ /g, '')
          .toLowerCase()
          .replace('/', ' / ')
          .replace(/\.00/g, '')
          .replace(/\.50/g, '.5')
          .replace('bedroom', ' Bedroom')
          .replace('bath', ' Bath')
      )
    )
  ]

  const donutChartThemeColors = {}
  unitTypes.sort().forEach(unit => {
    donutChartThemeColors[unit] =
      DONUT_CHART_COLOR_CODES[
        unit
          .trim()
          .replace(/ /g, '')
          .toLowerCase()
      ]

    const unittype = unit
      .trim()
      .replace(/ /g, '')
      .toLowerCase()
    if (unittype.startsWith('0bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Studio')) {
        donutChartThemeColors.Studio = DONUT_CHART_COLOR_CODES.studio
      }
    }
    if (unittype.startsWith('1bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('One Bedroom')) {
        donutChartThemeColors['One Bedroom'] =
          DONUT_CHART_COLOR_CODES.onebedroom
      }
    }
    if (unittype.startsWith('2bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Two Bedroom')) {
        donutChartThemeColors['Two Bedroom'] =
          DONUT_CHART_COLOR_CODES.twobedroom
      }
    }
    if (unittype.startsWith('3bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Three Bedroom')) {
        donutChartThemeColors['Three Bedroom'] =
          DONUT_CHART_COLOR_CODES.threebedroom
      }
    }
    if (unittype.startsWith('4bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Four Bedroom')) {
        donutChartThemeColors['Four Bedroom'] =
          DONUT_CHART_COLOR_CODES.fourbedroom
      }
    }
    if (unittype.startsWith('5bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Five Bedroom')) {
        donutChartThemeColors['Five Bedroom'] =
          DONUT_CHART_COLOR_CODES.fivebedroom
      }
    }
    if (unittype.startsWith('6bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Six Bedroom')) {
        donutChartThemeColors['Six Bedroom'] =
          DONUT_CHART_COLOR_CODES.sixbedroom
      }
    }
    if (unittype.startsWith('7bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Seven Bedroom')) {
        donutChartThemeColors['Seven Bedroom'] =
          DONUT_CHART_COLOR_CODES.sevenbedroom
      }
    }
    if (unittype.startsWith('8bedroom')) {
      if (!donutChartThemeColors.hasOwnProperty('Eight Bedroom')) {
        donutChartThemeColors['Eight Bedroom'] =
          DONUT_CHART_COLOR_CODES.eightbedroom
      }
    }
  })

  return donutChartThemeColors
}

const getUnitMixCount = (toggles, payload, templateName) => {
  const toggleSettings = {
    ...toggles,
    ...payload
  }

  const { hasAmenities, hasDonut, hasBranding, hasPageTitle } = toggleSettings

  if (templateName === 'rentCompsT4') {
    let unitmixCount =
      hasAmenities && hasDonut
        ? dataLimits.T4.unitMixCount
        : !hasAmenities && !hasDonut
        ? MAX_UNITMIX_COUNT_T4
        : LARGE_UNITMIX_COUNT_T4
    if (!hasBranding && !hasPageTitle) {
      unitmixCount += 3
    }

    return unitmixCount
  }

  if (templateName === 'rentCompsT3') {
    return !hasBranding && !hasPageTitle
      ? MAX_UNITMIX_COUNT_T3
      : dataLimits.T3.unitMixCount
  }

  return hasAmenities ? dataLimits.T1.unitMixCount : UNITMIX_COUNT_T1
}

const getNotesCount = (toggles, payload, templateName) => {
  const toggleSettings = {
    ...toggles,
    ...payload
  }
  const { hasDonut } = toggleSettings
  let { notesCount: notesCountResult } = dataLimits.T1

  if (hasDonut) {
    switch (templateName) {
      case 'studentHousingComps':
        notesCountResult = dataLimits.SH1.notesCount
        break
      case 'rentCompsT3':
        notesCountResult = dataLimits.T3.notesCount
        break
      default:
        notesCountResult = dataLimits.T1.notesCount
    }
  } else {
    switch (templateName) {
      case 'studentHousingComps':
        notesCountResult = MAX_NOTES_COUNT_SH1
        break
      case 'rentCompsT3':
        notesCountResult = MAX_NOTES_COUNT_T3
        break
      default:
        notesCountResult = MAX_NOTES_COUNT_T1
    }
  }

  return notesCountResult
}

const getAmenitiesCount = (toggles, payload) => {
  const toggleSettings = {
    ...toggles,
    ...payload
  }
  const { hasDonut } = toggleSettings

  return hasDonut ? dataLimits.T2.amenitiesCount : MAX_AMENITIES_COUNT_T2
}

const updateCompsDataOnToggleAction = (
  compsData,
  unitMixCount,
  templateName
) => {
  if (!templateName.includes(SALES_COMPARABLES)) {
    compsData.forEach(compsProperty => {
      if (compsProperty.comparableData?.length > 0) {
        const updatedComparableData = normalize.calculateWtdAvgRowForUnitMix(
          compsProperty.comparableData,
          unitMixCount
        )
        const {
          unitSize,
          unitMarketRent,
          units,
          mrPerSf
        } = updatedComparableData[updatedComparableData.length - 1]

        compsProperty.avgSf = unitSize
        compsProperty.avgMarketRentSf = unitMarketRent
        compsProperty.units = units
        compsProperty.avgRentSf = mrPerSf
        compsProperty.propertyData.averageSf = unitSize
        compsProperty.propertyData.avgMarketRentSf = unitMarketRent
        compsProperty.propertyData.units = units
        compsProperty.propertyData.avgRentSf = mrPerSf
        if (
          updatedComparableData[
            updatedComparableData.length - 1
          ].hasOwnProperty('beds')
        ) {
          const { beds, erPerBed } = updatedComparableData[
            updatedComparableData.length - 1
          ]
          compsProperty.beds = beds
          compsProperty.mrPerBed = erPerBed
          compsProperty.propertyData.beds = beds
        }

        compsProperty.comparableData = updatedComparableData

        compsProperty.chartData = normalize.calculateDonutChartData(
          compsProperty.comparableData,
          unitMixCount,
          templateName
        )
      }
    })
  }

  return compsData
}

const getDataLimitObjByTemplateName = templateName => {
  let dataLimitObj
  for (const [, value] of Object.entries(dataLimits)) {
    if (value.templateName === templateName) {
      dataLimitObj = value
    }
  }

  return dataLimitObj
}

const setCompsData = templateName => {
  if (templateName.includes(SALES_COMPARABLES)) {
    return {
      propertyFields: PROPERTY_FIELDS_SALES,
      summaryTableColumns: SUMMARY_TABLE_COLUMNS_SALES,
      subjectPropertyFields: PROPERTY_FIELDS_SALES,
      templateDataLimits: { ...dataLimits.S1 },
      templateType: dataLimits.S1.key,
      unitMixTableColumns: []
    }
  } else if (templateName.includes(SH_COMPARABLES)) {
    return {
      propertyFields: PROPERTY_FIELDS_SH,
      summaryTableColumns: SUMMARY_TABLE_COLUMNS_SH,
      subjectPropertyFields: PROPERTY_FIELDS_SH,
      templateDataLimits: { ...dataLimits.SH1 },
      templateType: dataLimits.SH1.key,
      unitMixTableColumns: UNITMIX_TABLE_COLUMNS_SH1
    }
  }

  return {
    propertyFields: PROPERTY_FIELDS_RENT,
    summaryTableColumns: SUMMARY_TABLE_COLUMNS_RENT,
    subjectPropertyFields: PROPERTY_FIELDS_RENT,
    templateDataLimits: { ...dataLimits.T1 },
    templateType: dataLimits.T1.key,
    unitMixTableColumns: UNITMIX_TABLE_COLUMNS_T1
  }
}

export const DEFAULT_STATE = {
  compsData: [],
  favoriteClick: false,
  fetchProjectLoading: false,
  fetchRecentProjectLoading: false,
  selectedProjectId: null,
  resetflag: false,
  templateName: null,
  projectName: null,
  isPropertyDataReady: false,
  isPropImagesNotLoaded: false,
  toggleSettings: {
    templateType: dataLimits.T1.key,
    hasBranding: true,
    hasNotes: true,
    hasSourceNotes: true,
    hasAmenities: true,
    hasPageTitle: true,
    hasDonut: true,
    hasUnitMix: true
  },
  templateDataLimits: { ...dataLimits.T1 },
  propertyFields: [],
  subjectPropertyFields: [],
  barChartSettings: {
    isSummaryBarCharts: true,
    isFloorPlan: true,
    isGrid: 'show',
    isValueOrientation: 'show',
    subjectPropBarColor: BAR_CHART_COLOR_CODES.subjectPropBarColor,
    compPropBarColor: BAR_CHART_COLOR_CODES.compPropBarColor,
    wtdAvgLineBarColor: BAR_CHART_COLOR_CODES.wtdAvgLineBarColor,
    propertyNameOrientation: 'default',
    barChartLayoutOptions: [],
    fpbarChartLayoutOptions: [],
    barWidth: 40
  },
  templates,
  salesTemplates,
  studentHousingTemplates,
  baseCompsData: '',
  barChartData: [],
  fpBarChartData: [],
  fpSummaryData: [],
  themeColors: { ...THEME_COLOR_CODES },
  isDialogOpen: false,
  dialogType: '',
  dealNumber: '',
  office: '',
  isPortfolio: false,
  recentProjects: [],
  allProjects: [],
  recentPagination: { offset: 0, limit: 20, queryParams: {} },
  mapsPagination: { offset: 0, limit: 20 },
  pagination: { offset: 0, limit: 20, queryParams: {} },
  isDeleted: false,
  regions: [],
  totalProjectsText: '',
  summaryTableColumns: [],
  unitMixTableColumns: [],
  citylookUp: [],
  ownerlookUp: [],
  fpSummaryTableColumns: {
    studio: [],
    '1 bedroom': [],
    '2 bedroom': [],
    '3 bedroom': [],
    '4 bedroom': [],
    '5 bedroom': [],
    '6 bedroom': [],
    '7 bedroom': [],
    '8 bedroom': []
  },
  summaryDisclaimerText: { disclaimerText: '', showDisclaimer: true },
  compsWithSubjectProperty: true,
  isSubjectPropertyDeleted: false,
  propertySearchData: [],
  isListRefreshed: false,
  listName: '',
  listInfo: {},
  listInfoLoading: '',
  polarisPropertySearchCriteriaId: '',
  activeTabIndex: 0,
  omniViewPropertyListId: '',
  mapProjects: [],
  mapPageNo: 0,
  recentMapProjects: [],
  totalMapsCount: 0,
  isMapsSelected: false
}

const bedRoomTypesObj = {
  'One Bedroom': '1 Bedroom',
  'Two Bedroom': '2 Bedroom',
  'Three Bedroom': '3 Bedroom',
  'Four Bedroom': '4 Bedroom',
  'Five Bedroom': '5 Bedroom',
  'Six Bedroom': '6 Bedroom',
  'Seven Bedroom': '7 Bedroom',
  'Eight Bedroom': '8 Bedroom'
}
const donutColorUpdateHelper = obj => {
  const { bedroomType, payload, donutChartThemeColors } = obj
  const unitTypes = Object.keys(donutChartThemeColors)
  donutChartThemeColors[bedroomType] = payload[bedroomType]
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 0.75 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 0.75 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 1 Bath`)) {
    donutChartThemeColors[`${bedRoomTypesObj[bedroomType]} / 1 Bath`] =
      payload[bedroomType]
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 1.5 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 1.5 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.85)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 1.75 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 1.75 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 2 Bath`)) {
    donutChartThemeColors[`${bedRoomTypesObj[bedroomType]} / 2 Bath`] = payload[
      bedroomType
    ]
      .trim()
      .replace(/1\)/, '0.7)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 2.5 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 2.5 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.55)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 2.75 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 2.75 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 3 Bath`)) {
    donutChartThemeColors[`${bedRoomTypesObj[bedroomType]} / 3 Bath`] = payload[
      bedroomType
    ]
      .trim()
      .replace(/1\)/, '0.4)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 3.5 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 3.5 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.25)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 3.75 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 3.75 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 4 Bath`)) {
    donutChartThemeColors[`${bedRoomTypesObj[bedroomType]} / 4 Bath`] = payload[
      bedroomType
    ]
      .trim()
      .replace(/1\)/, '0.1)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 4.5 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 4.5 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 4.75 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 4.75 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 5 Bath`)) {
    donutChartThemeColors[`${bedRoomTypesObj[bedroomType]} / 5 Bath`] = payload[
      bedroomType
    ]
      .trim()
      .replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 5.5 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 5.5 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 5.75 Bath`)) {
    donutChartThemeColors[
      `${bedRoomTypesObj[bedroomType]} / 5.75 Bath`
    ] = payload[bedroomType].trim().replace(/1\)/, '0.9)')
  }
  if (unitTypes.includes(`${bedRoomTypesObj[bedroomType]} / 6 Bath`)) {
    donutChartThemeColors[`${bedRoomTypesObj[bedroomType]} / 6 Bath`] = payload[
      bedroomType
    ]
      .trim()
      .replace(/1\)/, '0.9)')
  }

  return donutChartThemeColors
}

const setTruncatedFlag = (compsData, templateDataLimits, toggleSettings) => {
  if (compsData && templateDataLimits && toggleSettings) {
    const {
      hasAmenities,
      hasNotes,
      hasSourceNotes,
      hasUnitMix
    } = toggleSettings
    const {
      amenitiesCount,
      notesCount,
      sourceNotesCount,
      unitMixCount
    } = templateDataLimits

    compsData.forEach(obj => {
      const { comparableData, propertyData } = obj
      const { amenities, notes, sourceNote } = propertyData || {}
      if (toggleSettings.templateType === 'S1') {
        obj.isTruncated =
          hasSourceNotes && sourceNote?.length > sourceNotesCount
      } else {
        obj.isTruncated =
          (hasAmenities && amenities?.length > amenitiesCount) ||
          (hasNotes && notes?.length > notesCount) ||
          (hasSourceNotes && sourceNote?.length > sourceNotesCount) ||
          (hasUnitMix && comparableData?.length > unitMixCount)
      }
    })
  }

  return compsData || []
}

const templateToggleSettings = toggleSettings => {
  const noShowList = ['T5', 'T6', 'S1', 'S2']
  if (toggleSettings && noShowList.includes(toggleSettings.templateType)) {
    return {
      hasAmenities: false,
      hasNotes: false,
      hasSourceNotes:
        toggleSettings.templateType === 'S1'
          ? toggleSettings.hasSourceNotes
          : false,
      hasUnitMix: false,
      templateType: toggleSettings.templateType
    }
  }

  return toggleSettings
}

// eslint-disable-next-line complexity
export default function(state = { ...DEFAULT_STATE }, action) {
  switch (action.type) {
    case constants.RESET_COMPS.ACTION: {
      const baseCompsData = JSON.parse(state.baseCompsData)
      const { compsData, templateDataLimits, toggleSettings } = baseCompsData
      const compsDataWithTruncate = setTruncatedFlag(
        compsData,
        templateDataLimits,
        templateToggleSettings(toggleSettings)
      )

      return {
        ...DEFAULT_STATE,
        baseCompsData: state.baseCompsData,
        compsData: [...compsDataWithTruncate],
        templateName: baseCompsData.templateName,
        projectName: baseCompsData.projectName,
        projectNameCopy: baseCompsData.projectName,
        barChartData: baseCompsData.barChartData,
        fpBarChartData: baseCompsData.fpBarChartData,
        fpSummaryData: baseCompsData.fpSummaryData,
        barChartSettings: baseCompsData.barChartSettings,
        templateDataLimits: baseCompsData.templateDataLimits,
        toggleSettings: baseCompsData.toggleSettings,
        propertyFields: baseCompsData.propertyFields,
        subjectPropertyFields: baseCompsData.subjectPropertyFields,
        selectedProjectId: baseCompsData.selectedProjectId,
        themeColors: baseCompsData.themeColors,
        donutChartThemeColors: baseCompsData.donutChartThemeColors,
        summaryTableColumns: baseCompsData.summaryTableColumns,
        unitMixTableColumns: baseCompsData.unitMixTableColumns,
        dealNumber: baseCompsData.dealNumber,
        office: baseCompsData.office,
        fpSummaryTableColumns: baseCompsData.fpSummaryTableColumns,
        compsWithSubjectProperty: baseCompsData.compsWithSubjectProperty,
        isSubjectPropertyDeleted: baseCompsData.isSubjectPropertyDeleted,
        propertySearchData: baseCompsData.propertySearchData,
        polarisPropertySearchCriteriaId:
          baseCompsData.polarisPropertySearchCriteriaId,
        omniViewPropertyListId: baseCompsData.omniViewPropertyListId,
        listName: baseCompsData.listName
      }
    }
    case constants.SET_COMPS.FULFILLED: {
      const { templateName } = action.payload
      const {
        propertyFields,
        summaryTableColumns,
        subjectPropertyFields,
        templateDataLimits,
        templateType,
        unitMixTableColumns
      } = setCompsData(templateName)
      const compsWithSubjectProperty = action.payload.compsData.some(prop =>
        prop.propertyType.toString().includes('S')
      )
      const subjectPropBarColor = compsWithSubjectProperty
        ? state.barChartSettings.subjectPropBarColor
        : state.barChartSettings.compPropBarColor
      const projectName = action.payload && action.payload.projectName
      const projectNameCopy = projectName
      const isSummaryBarCharts = templateName !== SH_COMPARABLES
      const { barChartData, fpSummaryData, fpBarChartData } = action.payload
      const barChartLayoutOptions = getBarChartLayoutOptions(barChartData)
      const fpbarChartLayoutOptions = getFloorPlanBarChartLayoutOptions(
        fpSummaryData,
        fpBarChartData
      )
      const { themeColors, isSubjectPropertyDeleted } = DEFAULT_STATE
      const donutChartThemeColors = getAllunitTypes(action.payload.compsData)
      const fpSummaryTableColumns = {
        studio: FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '1 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '2 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '3 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '4 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '5 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '6 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '7 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '8 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS
      }
      const toggleSettings = { ...state.toggleSettings, templateType }
      let compsDataWithTruncate = setTruncatedFlag(
        action.payload.compsData,
        templateDataLimits,
        toggleSettings
      )
      compsDataWithTruncate = updateCompsDataOnToggleAction(
        compsDataWithTruncate,
        templateDataLimits.unitMixCount,
        templateName
      )

      return {
        ...state,
        baseCompsData: JSON.stringify({
          compsData: [...compsDataWithTruncate],
          templateName,
          projectName,
          projectNameCopy,
          propertyFields,
          subjectPropertyFields,
          barChartData,
          fpSummaryData,
          fpBarChartData,
          barChartSettings: {
            ...state.barChartSettings,
            isSummaryBarCharts,
            barChartLayoutOptions,
            fpbarChartLayoutOptions,
            subjectPropBarColor
          },
          templateDataLimits,
          toggleSettings,
          themeColors,
          donutChartThemeColors,
          summaryTableColumns,
          fpSummaryTableColumns,
          unitMixTableColumns,
          compsWithSubjectProperty,
          isSubjectPropertyDeleted
        }),
        compsData: action.payload.compsData,
        templateName,
        projectName,
        projectNameCopy,
        propertyFields,
        subjectPropertyFields,
        barChartData,
        fpSummaryData,
        fpBarChartData,
        isPropertyDataReady: true,
        barChartSettings: {
          ...state.barChartSettings,
          isSummaryBarCharts,
          barChartLayoutOptions,
          fpbarChartLayoutOptions,
          subjectPropBarColor
        },
        templateDataLimits,
        toggleSettings,
        donutChartThemeColors,
        summaryTableColumns,
        fpSummaryTableColumns,
        unitMixTableColumns,
        compsWithSubjectProperty
      }
    }
    case constants.RE_ARRANGE_COMPS.ACTION: {
      const indexFrom = action.payload && action.payload.indexFrom
      const indexTo = action.payload && action.payload.indexTo
      const { propertyType } = action.payload
      let properties
      const subjectPropertiesArr = state.compsData.filter(prop =>
        prop.propertyType.toString().includes('S')
      )
      if (!state.compsWithSubjectProperty) {
        properties = state.compsData.filter(
          property => property.propertyType !== 'NA'
        )
      } else {
        properties = state.compsData.filter(
          property =>
            property.propertyType !== 'NA' &&
            !property.propertyType.toString().includes('S') &&
            !property.propertyType.toString().includes('s')
        )
      }
      if (propertyType === 'subject') {
        let reArrangedProps = move(indexFrom, indexTo, subjectPropertiesArr)
        reArrangedProps = reArrangedProps.map((property, index) => {
          property.propertyData.propertyType = `S${index + 1}`
          property.propertyType = `S${index + 1}`

          return property
        })
        state.compsData.splice(
          0,
          subjectPropertiesArr.length,
          ...reArrangedProps
        )
      } else {
        let reArrangedProps = move(indexFrom, indexTo, properties)
        reArrangedProps = reArrangedProps.map((property, index) => {
          property.propertyData.propertyType = index + 1
          property.propertyType = index + 1

          return property
        })
        state.compsData.splice(
          state.compsWithSubjectProperty
            ? subjectPropertiesArr?.length
              ? subjectPropertiesArr?.length
              : 1
            : 0,
          reArrangedProps.length,
          ...reArrangedProps
        )
      }

      return { ...state, compsData: [...state.compsData], resetflag: true }
    }

    case constants.EDIT_UNITMIX_DATA.ACTION: {
      const comparableData = action.payload && action.payload.comparableData
      const propertyType = action.payload && action.payload.propertyType
      const unitMixDisclaimerData =
        action.payload && action.payload.unitMixDisclaimerData
      const { compsData, templateDataLimits, toggleSettings } = { ...state }
      const { unitSize, unitMarketRent, units, mrPerSf } = comparableData[
        comparableData.length - 1
      ]
      compsData.forEach(property => {
        if (property.propertyType === propertyType) {
          property.comparableData = [...comparableData]
          // eslint-disable-next-line no-unused-expressions
          property.comparableData.some(
            unitMix =>
              unitMix.source === 'BCM' &&
              (unitMix.isAdded === true ||
                unitMix.isModified === true ||
                unitMix.isRemoved === true)
          )
            ? (property.fieldsForOvSync = {
                ...property.fieldsForOvSync,
                isUnitMixModified: true
              })
            : (property.fieldsForOvSync = {
                ...property.fieldsForOvSync,
                isUnitMixModified: false
              })
          property.avgSf = unitSize
          property.avgMarketRentSf = unitMarketRent
          property.units = units
          property.avgRentSf = mrPerSf
          property.propertyData.averageSf = unitSize
          property.propertyData.avgMarketRentSf = unitMarketRent
          property.propertyData.units = units
          property.propertyData.avgRentSf = mrPerSf
          if (
            comparableData[comparableData.length - 1].hasOwnProperty('beds')
          ) {
            const { beds, erPerBed } = comparableData[comparableData.length - 1]
            property.beds = beds
            property.mrPerBed = erPerBed
            property.propertyData.beds = beds
          }
          property.chartData = normalize.calculateDonutChartData(
            comparableData,
            templateDataLimits.unitMixCount,
            templateDataLimits.templateName
          )
          property.unitMixDisclaimerData = unitMixDisclaimerData
        }
      })
      const propertySummaryData = normalize.normalizePropertyDeleted(
        state,
        null
      )
      const donutChartThemeColorsCopy = getAllunitTypes(
        propertySummaryData.updatedProperties
      )

      const updatedCompsData = [...propertySummaryData.updatedProperties]
      const { templateName, barChartSettings, fpSummaryTableColumns } = state
      const updatedBarChartData = getChartData(
        updatedCompsData,
        templateName,
        barChartSettings
      )

      const compsDataWithTruncate = setTruncatedFlag(
        updatedCompsData,
        templateDataLimits,
        toggleSettings
      )

      const fpSummaryData = getFpData(updatedCompsData)
      const fpBarChartData = getFPBarChartData(fpSummaryData, barChartSettings)

      for (const obj in fpSummaryData) {
        if (
          fpSummaryData[obj].type &&
          !fpSummaryTableColumns[fpSummaryData[obj].type]
        ) {
          fpSummaryTableColumns[obj.type] = FLOOR_PLAN_SUMMARY_TABLE_COLUMNS
        }
      }

      return {
        ...state,
        compsData: [...compsDataWithTruncate],
        donutChartThemeColors: { ...donutChartThemeColorsCopy },
        barChartData: [...updatedBarChartData],
        fpSummaryData: [...fpSummaryData],
        fpBarChartData: [...fpBarChartData],
        fpSummaryTableColumns,
        resetflag: true,
        barChartSettings: { ...state.barChartSettings }
      }
    }

    case constants.CREATE_PROJECT_FROM_LIST.REJECTED:
    case constants.SET_COMPS.REJECTED: {
      return { ...state, isPropImagesNotLoaded: true }
    }
    case constants.CLEAR_COMPS.ACTION: {
      return { ...DEFAULT_STATE }
    }
    case constants.UPDATE_COMPS.ACTION:
      return { ...state, compsData: action.payload }

    case constants.DOWNLOAD_PDF_S3.FULFILLED: {
      const downloadLink = document.createElement('a')
      downloadLink.href = action.payload.url
      downloadLink.target = '_blank'
      downloadLink.click()

      return { ...state }
    }
    case constants.DELETE_PROPERTY.ACTION: {
      const compsData = normalize.normalizePropertyDeleted(
        state,
        action.payload.deleteProperty
      )
      let { isSubjectPropertyDeleted, compsWithSubjectProperty } = state
      if (action.payload.deleteProperty.propertyType.toString().includes('S')) {
        isSubjectPropertyDeleted = true
        compsWithSubjectProperty = false
      }
      compsData.updatedProperties.forEach(obj => {
        if (obj.propertyType?.toString().includes('S')) {
          compsWithSubjectProperty = true
        }
      })
      const barChartLayoutOptions = filterLayoutOptionsAfterPropertyDelete(
        compsData.barChartData,
        state.barChartSettings.barChartLayoutOptions
      )
      // const fpbarChartLayoutOptions = getFloorPlanBarChartLayoutOptions(compsData.fpSummaryData, compsData.fpBarChartData)
      const fpbarChartLayoutOptions =
        state.barChartSettings.isFloorPlan !== undefined
          ? filterFpLayoutOptionsAfterPropertyDelete(
              compsData.fpSummaryData,
              compsData.fpBarChartData,
              state.barChartSettings.fpbarChartLayoutOptions
            )
          : undefined

      return {
        ...state,
        compsData: [...compsData.updatedProperties],
        barChartData: compsData.barChartData,
        fpSummaryData: compsData.fpSummaryData,
        fpBarChartData: compsData.fpBarChartData,
        resetflag: true,
        compsWithSubjectProperty,
        isSubjectPropertyDeleted,
        barChartSettings: {
          ...state.barChartSettings,
          barChartLayoutOptions,
          fpbarChartLayoutOptions
        }
      }
    }
    case constants.TOGGLE_FEATURE.ACTION: {
      const defaultToggles = state.toggleSettings
      let selectedTemplate = {
        ...state.templateDataLimits,
        templateName: state.templateName
      }
      if (action.payload.hasOwnProperty('templateType')) {
        selectedTemplate = { ...setDataLimits(action.payload.templateType) }
        const toggleSettings = { ...defaultToggles, ...action.payload }

        const propertyFields = getFields(
          action.payload.templateType,
          state.propertyFields
        )
        const subjectPropertyFields = getFields(
          action.payload.templateType,
          state.subjectPropertyFields
        )
        const unitMixTableColumns = getunitMixTableFields(
          action.payload.templateType,
          state.unitMixTableColumns
        )
        const summaryTableColumns = getSummaryColumns(
          action.payload.templateType,
          selectedTemplate.templateName
        )
        let {
          notesCount,
          unitMixCount,
          amenitiesCount
        } = getDataLimitObjByTemplateName(selectedTemplate.templateName)
        if (selectedTemplate.templateName === RENT_COMPARABLES) {
          if (!state.toggleSettings.hasDonut) {
            notesCount = MAX_NOTES_COUNT_T1
          }
          if (!state.toggleSettings.hasAmenities) {
            unitMixCount = UNITMIX_COUNT_T1
          }
        }

        if (selectedTemplate.templateName === 'rentCompsT3') {
          if (!state.toggleSettings.hasDonut) {
            notesCount = MAX_NOTES_COUNT_T3
          }
          if (
            !state.toggleSettings.hasBranding &&
            !state.toggleSettings.hasPageTitle
          ) {
            unitMixCount = MAX_UNITMIX_COUNT_T3
          }
        }

        if (selectedTemplate.templateName === 'rentCompsT2') {
          if (!state.toggleSettings.hasDonut) {
            amenitiesCount = MAX_AMENITIES_COUNT_T2
          }
        }

        if (selectedTemplate.templateName === 'rentCompsT4') {
          if (
            !state.toggleSettings.hasDonut ||
            !state.toggleSettings.hasAmenities
          ) {
            const { hasAmenities, hasDonut } = toggleSettings
            unitMixCount =
              hasAmenities && hasDonut
                ? dataLimits.T4.unitMixCount
                : !hasAmenities && !hasDonut
                ? MAX_UNITMIX_COUNT_T4
                : LARGE_UNITMIX_COUNT_T4
          }
          if (
            !state.toggleSettings.hasBranding &&
            !state.toggleSettings.hasPageTitle
          ) {
            unitMixCount += 3
          }
        }

        if (selectedTemplate.templateName === SH_COMPARABLES) {
          if (!state.toggleSettings.hasDonut) {
            notesCount = MAX_NOTES_COUNT_SH1
          }
          if (!state.toggleSettings.hasAmenities) {
            unitMixCount = UNITMIX_COUNT_SH1
          }
        }
        const newTemplateDataLimits = {
          ...selectedTemplate,
          notesCount,
          unitMixCount,
          amenitiesCount
        }
        const updatedCompsData = updateCompsDataOnToggleAction(
          state.compsData,
          unitMixCount,
          selectedTemplate.templateName
        )
        const compsDataWithTruncateFlag = setTruncatedFlag(
          updatedCompsData,
          newTemplateDataLimits,
          toggleSettings
        )

        return {
          ...state,
          compsData: [...compsDataWithTruncateFlag],
          summaryTableColumns,
          unitMixTableColumns,
          toggleSettings,
          templateDataLimits: newTemplateDataLimits,
          templateName: selectedTemplate.templateName,
          propertyFields,
          subjectPropertyFields
        }
      }

      if (
        selectedTemplate.templateName === 'rentCompsT4' &&
        (action.payload.hasOwnProperty('hasAmenities') ||
          action.payload.hasOwnProperty('hasDonut') ||
          action.payload.hasOwnProperty('hasBranding') ||
          action.payload.hasOwnProperty('hasPageTitle'))
      ) {
        const toggleSettings = { ...defaultToggles, ...action.payload }
        const unitMixCount = getUnitMixCount(
          state.toggleSettings,
          action.payload,
          state.templateName
        )
        const newTemplateDataLimits = {
          ...state.templateDataLimits,
          unitMixCount
        }
        const updatedCompsData = updateCompsDataOnToggleAction(
          state.compsData,
          unitMixCount,
          selectedTemplate.templateName
        )
        const compsDataWithTruncateFlag = setTruncatedFlag(
          updatedCompsData,
          newTemplateDataLimits,
          toggleSettings
        )

        return {
          ...state,
          compsData: [...compsDataWithTruncateFlag],
          toggleSettings,
          resetflag: true,
          templateDataLimits: newTemplateDataLimits
        }
      }
      if (
        (selectedTemplate.templateName === RENT_COMPARABLES ||
          selectedTemplate.templateName === SH_COMPARABLES) &&
        (action.payload.hasOwnProperty('hasDonut') ||
          action.payload.hasOwnProperty('hasAmenities'))
      ) {
        const toggleSettings = { ...defaultToggles, ...action.payload }
        const unitMixCount = getUnitMixCount(
          state.toggleSettings,
          action.payload,
          state.templateName
        )
        const newTemplateDataLimits = {
          ...state.templateDataLimits,
          notesCount: getNotesCount(
            state.toggleSettings,
            action.payload,
            selectedTemplate.templateName
          ),
          unitMixCount
        }
        const updatedCompsData = updateCompsDataOnToggleAction(
          state.compsData,
          unitMixCount,
          selectedTemplate.templateName
        )
        const compsDataWithTruncateFlag = setTruncatedFlag(
          updatedCompsData,
          newTemplateDataLimits,
          toggleSettings
        )

        return {
          ...state,
          compsData: [...compsDataWithTruncateFlag],
          toggleSettings,
          resetflag: true,
          templateDataLimits: newTemplateDataLimits
        }
      }

      if (
        selectedTemplate.templateName === 'rentCompsT3' &&
        (action.payload.hasOwnProperty('hasDonut') ||
          action.payload.hasOwnProperty('hasBranding') ||
          action.payload.hasOwnProperty('hasPageTitle'))
      ) {
        const toggleSettings = { ...defaultToggles, ...action.payload }
        const unitMixCount = getUnitMixCount(
          state.toggleSettings,
          action.payload,
          state.templateName
        )
        const notesCount = getNotesCount(
          state.toggleSettings,
          action.payload,
          selectedTemplate.templateName
        )
        const newTemplateDataLimits = {
          ...state.templateDataLimits,
          notesCount,
          unitMixCount
        }
        const compsDataWithTruncateFlag = setTruncatedFlag(
          state.compsData,
          newTemplateDataLimits,
          toggleSettings
        )

        return {
          ...state,
          compsData: [...compsDataWithTruncateFlag],
          toggleSettings,
          resetflag: true,
          templateDataLimits: newTemplateDataLimits
        }
      }

      if (
        selectedTemplate.templateName === 'rentCompsT2' &&
        action.payload.hasOwnProperty('hasDonut')
      ) {
        const toggleSettings = { ...defaultToggles, ...action.payload }
        const amenitiesCount = getAmenitiesCount(
          state.toggleSettings,
          action.payload
        )
        const newTemplateDataLimits = {
          ...state.templateDataLimits,
          amenitiesCount
        }
        const compsDataWithTruncateFlag = setTruncatedFlag(
          state.compsData,
          newTemplateDataLimits,
          toggleSettings
        )

        return {
          ...state,
          compsData: [...compsDataWithTruncateFlag],
          toggleSettings,
          resetflag: true,
          templateDataLimits: newTemplateDataLimits
        }
      }

      const toggleSettings = { ...defaultToggles, ...action.payload }
      const { templateDataLimits, compsData } = state
      const compsDataWithTruncate = setTruncatedFlag(
        compsData,
        templateDataLimits,
        toggleSettings
      )

      return {
        ...state,
        compsData: [...compsDataWithTruncate],
        toggleSettings,
        templateDataLimits,
        resetflag: true
      }
    }
    case constants.EDIT_FEATURE.ACTION: {
      const { isNotesModified, ...propInfo } = action.payload
      const compsData = [...state.compsData]
      compsData.forEach(property => {
        if (property.propertyType === propInfo.propertyType) {
          property.propertyData = propInfo
          // eslint-disable-next-line no-unused-expressions
          isNotesModified
            ? (property.fieldsForOvSync = {
                ...property.fieldsForOvSync,
                isNotesModified
              })
            : null
        }
      })

      const compsDataWithTruncate = setTruncatedFlag(
        compsData,
        state.templateDataLimits,
        templateToggleSettings(state.toggleSettings)
      )

      return {
        ...state,
        compsData: [...compsDataWithTruncate],
        resetflag: true
      }
    }
    case constants.EDIT_DONUTCHART_COLORS.ACTION:
      let tempDonutChartThemeColors = state.donutChartThemeColors
      const unitTypes = Object.keys(tempDonutChartThemeColors)
      const flag = action.payload.action
      delete action.payload.action
      const updatedColorType = Object.keys(action.payload)
      if (flag === undefined || flag) {
        if (flag || tempDonutThemeColorObj === null) {
          tempDonutThemeColorObj = { ...state.donutChartThemeColors }
        }
        if (updatedColorType[0] === 'Studio') {
          if (unitTypes.includes('0 Bedroom / 1 Bath')) {
            tempDonutChartThemeColors.Studio =
              action.payload[updatedColorType[0]]
            tempDonutChartThemeColors['0 Bedroom / 1 Bath'] =
              action.payload[updatedColorType[0]]
          }
        } else if (updatedColorType[0] === 'One Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'One Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Two Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Two Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Three Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Three Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Four Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Four Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Five Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Five Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Six Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Six Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Seven Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Seven Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else if (updatedColorType[0] === 'Eight Bedroom') {
          tempDonutChartThemeColors = donutColorUpdateHelper({
            bedroomType: 'Eight Bedroom',
            payload: action.payload,
            donutChartThemeColors: tempDonutChartThemeColors
          })
        } else {
          tempDonutChartThemeColors = {
            ...tempDonutChartThemeColors,
            ...action.payload
          }
        }
      } else {
        tempDonutChartThemeColors = { ...tempDonutThemeColorObj }
      }

      return {
        ...state,
        resetflag: state.resetflag || Boolean(flag),
        donutChartThemeColors: { ...tempDonutChartThemeColors }
      }
    case constants.FP_BAR_CHART_SETTINGS.ACTION:
      const fpbarChartLayoutOptions = [...state.barChartSettings.fpbarChartLayoutOptions]
      let updatedfpBarChartLayoutOptions = [...fpbarChartLayoutOptions]
      updatedfpBarChartLayoutOptions = fpbarChartLayoutOptions.map(
        layoutOption => {
          if (action.payload.pageTitle === layoutOption.pageTitle) {
            layoutOption.layout = action.payload.selectedLayoutValue
          }

          return layoutOption
        }
      )

      return {
        ...state,
        barChartSettings: {
          ...state.barChartSettings,
          fpbarChartLayoutOptions: [...updatedfpBarChartLayoutOptions]
        },
        resetflag: state.resetflag || Boolean(action.payload.action)
      }
    case constants.BAR_CHART_SETTINGS.ACTION:
      const { pageTitle, selectedLayoutValue } = action.payload
      normalize.normalizePropertyDeleted(state, action.payload.deleteProperty)
      const chartData = [...state.barChartData]
      const fpBarChartDataCopy = state.fpBarChartData && [...state.fpBarChartData]
      let updatedCharData = [...chartData]
      let updatedFpBarChartData = fpBarChartDataCopy && [...fpBarChartDataCopy]
      let customColorChoosen = null
      let { subjectPropBarColor } = state.barChartSettings
      const barChartLayoutOptions = [...state.barChartSettings.barChartLayoutOptions]
      let updatedBarChartLayoutOptions = [...barChartLayoutOptions]
      if (pageTitle && selectedLayoutValue === undefined) {
        updatedCharData =
          chartData &&
          chartData.map(data => {
            if (data.pageTitle === pageTitle) {
              data.chartData.yaxisConfig = { ...action.payload.yaxisConfig }
            }

            return data
          })

        updatedFpBarChartData =
          fpBarChartDataCopy &&
          fpBarChartDataCopy.map(data => {
            if (data.pageTitle === pageTitle) {
              data.chartData.yaxisConfig = { ...action.payload.yaxisConfig }
            }

            return data
          })
      } else if (selectedLayoutValue !== undefined) {
        // Do not change to !selectedLayoutValue as it carries 0 as well
        updatedBarChartLayoutOptions = barChartLayoutOptions.map(
          layoutOption => {
            if (pageTitle === layoutOption.pageTitle) {
              layoutOption.layout = selectedLayoutValue
            }

            return layoutOption
          }
        )
      } else {
        customColorChoosen = { ...action.payload }
        if (
          !state.compsWithSubjectProperty &&
          customColorChoosen.compPropBarColor
        ) {
          subjectPropBarColor = customColorChoosen.compPropBarColor
        }
        const subjectPropertyNames = state.compsData.reduce((prev, cur) => {
          if (cur.propertyType.toString().includes('S')) {
            return prev.concat(cur.name)
          }

          return prev
        }, [])

        updatedCharData = changeBarColors(
          state.barChartData,
          { ...state.barChartSettings, subjectPropBarColor, ...action.payload },
          subjectPropertyNames
        )
        if (state.fpBarChartData !== undefined) {
          updatedFpBarChartData = changeBarColors(
            state.fpBarChartData,
            {
              ...state.barChartSettings,
              subjectPropBarColor,
              ...action.payload
            },
            subjectPropertyNames
          )
        }
      }

      return {
        ...state,
        barChartData: [...updatedCharData],
        fpBarChartData: updatedFpBarChartData && [...updatedFpBarChartData],
        barChartSettings: {
          ...state.barChartSettings,
          ...customColorChoosen,
          isGrid: action.payload.isGrid || state.barChartSettings.isGrid,
          isValueOrientation:
            action.payload.isValueOrientation ||
            state.barChartSettings.isValueOrientation,
          propertyNameOrientation:
            action.payload.propertyNameOrientation ||
            state.barChartSettings.propertyNameOrientation,
          barChartLayoutOptions: [...updatedBarChartLayoutOptions]
        },
        barWidth: action.payload.barWidth,
        resetflag: state.resetflag || Boolean(action.payload.action)
      }
    case constants.EDIT_FILE_NAME.ACTION:
      return {
        ...state,
        projectName: action.payload.projectName,
        resetflag: true
      }
    case constants.EDIT_PROPERTY_DETAILS.ACTION:
      const { type, data, disclaimerTextData } = action.payload
      const summaryDisclaimerText = disclaimerTextData
      let keyField = 'summaryTableColumns'
      if (type === 'subject') {
        keyField = 'subjectPropertyFields'
      } else if (type === 'comparable') {
        keyField = 'propertyFields'
      } else if (type === 'floor') {
        keyField = 'fpSummaryTableColumns'
      }

      return {
        ...state,
        [keyField]: data,
        summaryDisclaimerText,
        resetflag: true
      }

    case constants.EDIT_COLUMNS_DETAILS.ACTION:
      return { ...state, ...action.payload, resetflag: true }

    case constants.THEME_COLOR_SETTINGS.ACTION:
      const themeColorChoosen = { ...action.payload }
      const updatedThemeColors = getUpdatedThemeColors(
        themeColorChoosen,
        state.themeColors
      )

      return {
        ...state,
        resetflag: state.resetflag || Boolean(action.payload.action),
        themeColors: {
          ...state.themeColors,
          ...themeColorChoosen,
          ...updatedThemeColors
        }
      }
    case constants.SHOW_POPUP_DIALOG.ACTION:
      const { isDialogOpen, dialogType } = action.payload

      return { ...state, isDialogOpen, dialogType }
    case constants.GET_PROJECT_BY_ID.ACTION:
      return { ...state, selectedProjectId: action.payload }
    case constants.GET_PROJECT_BY_ID.FULFILLED:
      const donutChartThemeColors =
        action.payload.data.donutChartThemeColors ||
        getAllunitTypes(action.payload.data.compsData)
      const unitMixTableColumns =
        action.payload.data.unitMixTableColumns ||
        (action.payload.data.templateName.includes(RENT_COMPARABLES)
          ? UNITMIX_TABLE_COLUMNS_T1
          : UNITMIX_TABLE_COLUMNS_SH1)
      const {
        compsData,
        templateDataLimits,
        toggleSettings,
        barChartSettings: barChartSettingsData,
        barChartData: savedBarChartData
      } = action.payload.data
      const compsDataWithTruncate = setTruncatedFlag(
        compsData,
        templateDataLimits,
        templateToggleSettings(toggleSettings)
      )

      const updatedBarChartData = mergeSavedYaxisConfig(
        getChartData(
          compsDataWithTruncate,
          templateDataLimits.templateName,
          barChartSettingsData
        ),
        savedBarChartData
      )

      return {
        ...state,
        ...action.payload.data,
        compsData: [...compsDataWithTruncate],
        donutChartThemeColors,
        unitMixTableColumns,
        barChartData: [...updatedBarChartData],
        baseCompsData: JSON.stringify({
          ...action.payload.data,
          donutChartThemeColors,
          selectedProjectId: state.selectedProjectId,
          barChartData: updatedBarChartData
        })
      }
    case constants.SAVE_COMPS_PROJECT.FULFILLED: {
      return {
        ...state,
        resetflag: false,
        ...action.payload,
        selectedProjectId: action.payload.projectGuid,
        baseCompsData: JSON.stringify({
          ...state,
          selectedProjectId: action.payload.projectGuid
        }),
        isListRefreshed: false
      }
    }

    case constants.UPDATE_COMPS_PROJECT.REJECTED:
    case constants.SAVE_COMPS_PROJECT.REJECTED:
    case constants.DOWNLOAD_PDF_S3.REJECTED:
    case constants.SEARCH_PROJECTS.REJECTED:
    case constants.DELETE_PROJECT.REJECTED:
    case constants.LOAD_REGIONS.REJECTED:
    case constants.GET_OFFICES.REJECTED: {
      return { ...state }
    }

    case constants.UPDATE_COMPS_PROJECT.ACTION: {
      return { ...state, status: 'inprogress...' }
    }

    case constants.UPDATE_COMPS_PROJECT.FULFILLED: {
      return {
        ...state,
        resetflag: false,
        ...action.payload,
        selectedProjectId: action.payload.projectGuid,
        baseCompsData: JSON.stringify({
          ...state,
          selectedProjectId: action.payload.projectGuid
        }),
        isListRefreshed: false
      }
    }
    case constants.GET_OFFICES.FULFILLED: {
      return { ...state, regions: action.payload.regions }
    }
    case constants.GET_RECENT_PROJECTS.ACTION: {
      return { ...state, fetchRecentProjectLoading: true }
    }
    case constants.GET_RECENT_PROJECTS.FULFILLED: {
      let recentProjects = []
      if (state.recentPagination.offset) {
        recentProjects = [...state.recentProjects, ...action.payload.data]
      } else {
        recentProjects = [...action.payload.data]
      }

      return {
        ...state,
        recentProjects,
        recentCount: action.payload.count,
        fetchRecentProjectLoading: false
      }
    }
    case constants.GET_RECENT_PROJECTS.REJECTED: {
      return { ...state, fetchRecentProjectLoading: false }
    }
    case constants.SEARCH_PROJECTS.FULFILLED: {
      return {
        ...state,
        allProjects: action.payload.data,
        count: action.payload.count,
        activeTabIndex: 0
      }
    }
    case constants.GET_PROPERTY_INFO.FULFILLED: {
      return {
        ...state,
        propertySearchData: action.payload.data?.[0],
        status: ''
      }
    }
    case constants.CREATE_PROJECT_FROM_LIST.FULFILLED: {
      const selectTemplateType = action.payload?.projectType
      const listName = action.payload?.listName
      const templateDataLimitss = { ...setDataLimits(selectTemplateType) }
      const fpSummaryTableColumns = {
        studio: FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '1 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '2 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '3 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '4 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '5 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '6 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '7 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS,
        '8 bedroom': FLOOR_PLAN_SUMMARY_TABLE_COLUMNS
      }
      const { themeColors } = DEFAULT_STATE

      // will create compsData object using OV list
      const compsDataCopy = normalize.createCompsDataFromOVList(
        action.payload?.listInfo,
        templateDataLimitss
      )

      const propertySummaryData = normalize.normalizePropertyDeleted(
        {
          compsData: compsDataCopy,
          templateName: templateDataLimitss.templateName,
          barChartSettings: state.barChartSettings
        },
        null
      )
      const toggleSettingsCopy = {
        ...state.toggleSettings,
        templateType: selectTemplateType
      }
      const compsDataTruncate = setTruncatedFlag(
        propertySummaryData.updatedProperties,
        templateDataLimitss,
        toggleSettingsCopy
      )
      const compsDataLimits = setCompsData(templateDataLimitss.templateName)
      const compsWithSubjectProperty = propertySummaryData.updatedProperties.some(
        prop => prop.propertyType.toString().includes('S')
      )

      const isSubjectPropertyDeleted = !compsWithSubjectProperty
      const subjectPropBarColorCopy = compsWithSubjectProperty
        ? state.barChartSettings.subjectPropBarColor
        : state.barChartSettings.compPropBarColor
      const projectName = state.listInfo?.name || listName
      const projectNameCopy = projectName
      const polarisPropertySearchCriteriaId =
        state.listInfo?.polarisPropertySearchCriteriaId
      const omniViewPropertyListId = state.listInfo?.omniViewPropertyListId
      const isSummaryBarCharts =
        templateDataLimitss.templateName !== SH_COMPARABLES
      const barChartLayoutOptionsCopy = getBarChartLayoutOptions(
        propertySummaryData.barChartData
      )
      const fpbarChartLayoutOptionsCopy = getFloorPlanBarChartLayoutOptions(
        propertySummaryData.fpSummaryData,
        propertySummaryData.fpBarChartData
      )
      const donutChartThemeColorsCopy = getAllunitTypes(
        propertySummaryData.updatedProperties
      )

      return {
        ...state,
        isPropertyDataReady: true,
        baseCompsData: JSON.stringify({
          compsData: [...compsDataTruncate],
          templateName: templateDataLimitss.templateName,
          projectName,
          projectNameCopy,
          polarisPropertySearchCriteriaId,
          omniViewPropertyListId,
          propertyFields: compsDataLimits.propertyFields,
          summaryTableColumns: compsDataLimits.summaryTableColumns,
          subjectPropertyFields: compsDataLimits.subjectPropertyFields,
          barChartData: propertySummaryData.barChartData,
          fpSummaryData: propertySummaryData.fpSummaryData,
          fpBarChartData: propertySummaryData.fpBarChartData,
          barChartSettings: {
            ...state.barChartSettings,
            isSummaryBarCharts,
            barChartLayoutOptions: barChartLayoutOptionsCopy,
            fpbarChartLayoutOptions: fpbarChartLayoutOptionsCopy,
            subjectPropBarColor: subjectPropBarColorCopy
          },
          templateDataLimits: compsDataLimits.templateDataLimits,
          toggleSettings: toggleSettingsCopy,
          themeColors,
          donutChartThemeColors: donutChartThemeColorsCopy,
          fpSummaryTableColumns,
          unitMixTableColumns: compsDataLimits.unitMixTableColumns,
          compsWithSubjectProperty,
          isSubjectPropertyDeleted,
          listName
        }),
        compsData: [...compsDataTruncate],
        barChartData: propertySummaryData.barChartData,
        fpSummaryData: propertySummaryData.fpSummaryData,
        fpBarChartData: propertySummaryData.fpBarChartData,
        templateName: templateDataLimitss.templateName,
        toggleSettings: toggleSettingsCopy,
        projectName,
        projectNameCopy,
        polarisPropertySearchCriteriaId,
        omniViewPropertyListId,
        propertyFields: compsDataLimits.propertyFields,
        summaryTableColumns: compsDataLimits.summaryTableColumns,
        subjectPropertyFields: compsDataLimits.subjectPropertyFields,
        templateDataLimits: compsDataLimits.templateDataLimits,
        templateType: compsDataLimits.templateType,
        unitMixTableColumns: compsDataLimits.unitMixTableColumns,
        donutChartThemeColors: donutChartThemeColorsCopy,
        barChartSettings: {
          ...state.barChartSettings,
          isSummaryBarCharts,
          barChartLayoutOptions: barChartLayoutOptionsCopy,
          fpbarChartLayoutOptions: fpbarChartLayoutOptionsCopy,
          subjectPropBarColor: subjectPropBarColorCopy
        },
        fpSummaryTableColumns,
        compsWithSubjectProperty,
        isSubjectPropertyDeleted,
        listName
      }
    }
    case constants.GET_LIST_INFO.ACTION: {
      return { ...state, listInfoLoading: 'InProgress' }
    }
    case constants.GET_LIST_INFO.FULFILLED: {
      if (action.payload.data) {
        return {
          ...state,
          listInfo: action.payload.data?.[0],
          listInfoLoading: 'Completed'
        }
      }

      return { ...state, listInfoLoading: '', listInfo: {} }
    }
    case constants.REFRESH_LIST_INFO.ACTION: {
      return { ...state, isListRefreshed: false }
    }
    case constants.REFRESH_LIST_INFO.REJECTED:
    case constants.GET_LIST_INFO.REJECTED: {
      return { ...state, listInfo: null, listInfoLoading: 'Completed' }
    }
    case constants.RESET_SELECTED_LIST_INFO.ACTION: {
      return { ...state, listInfoLoading: '', listInfo: {} }
    }
    case constants.GET_ALL_PROJECTS.ACTION: {
      return { ...state, fetchProjectLoading: true, isMapsSelected: false }
    }
    case constants.GET_ALL_PROJECTS.FULFILLED: {
      let allProjects = []
      if (state.pagination.offset) {
        allProjects = [...state.allProjects, ...action.payload.data]
      } else {
        allProjects = [...action.payload.data]
      }

      return {
        ...state,
        fetchProjectLoading: false,
        allProjects,
        count: action.payload.count,
        isMapsSelected: false
      }
    }
    case constants.GET_ALL_PROJECTS.REJECTED: {
      return { ...state, fetchProjectLoading: false, isMapsSelected: false }
    }
    case constants.GET_MAP_PROJECTS.ACTION: {
      return { ...state, fetchProjectLoading: true, isMapsSelected: true }
    }
    case constants.GET_MAP_PROJECTS.FULFILLED: {
      return {
        ...state,
        fetchProjectLoading: false,
        mapProjects:
          action.payload.offset === 0
            ? [...action.payload.maps]
            : [...state.mapProjects, ...action.payload.maps],
        mapPageNo: action.payload.offset === 0 ? 1 : state.pageNo,
        recentMapProjects: action.payload.recentMaps
          ? [...action.payload.recentMaps]
          : [],
        totalMapsCount: action.payload.totalCount,
        isMapsSelected: true
      }
    }
    case constants.GET_MAP_PROJECTS.REJECTED: {
      return { ...state, fetchProjectLoading: false, isMapsSelected: true }
    }
    case constants.SET_PAGINATION.ACTION: {
      return {
        ...state,
        pagination: { ...state.pagination, ...action.payload }
      }
    }
    case constants.SET_RECENT_PAGINATION.ACTION: {
      return {
        ...state,
        recentPagination: { ...state.recentPagination, ...action.payload }
      }
    }
    case constants.SET_MAPS_PAGINATION.ACTION: {
      return {
        ...state,
        mapsPagination: { ...state.mapsPagination, ...action.payload }
      }
    }
    case constants.DELETE_PROJECT.FULFILLED: {
      return { ...state, ...action.payload, selectedProjectId: null }
    }
    case constants.LOAD_REGIONS.FULFILLED: {
      return { ...state, regions: action.payload.data }
    }
    case constants.SET_TOTAL_PROJECTS_TEXT.ACTION: {
      return { ...state, ...action.payload }
    }
    case constants.SET_PROJECT_AS_FAVORITE.ACTION: {
      const { allProjects, recentProjects } = state
      const favProjectfromAll = allProjects.find(
        proj => proj.id === action.payload.projectId
      )
      const favProjectfromRecent = recentProjects.find(
        proj => proj.id === action.payload.projectId
      )
      if (favProjectfromAll) {
        favProjectfromAll.isFavorited = action.payload.favorite
      }
      if (favProjectfromRecent) {
        favProjectfromRecent.isFavorited = action.payload.favorite
      }

      return {
        ...state,
        allProjects,
        recentProjects,
        favoriteClick: !state.favoriteClick
      }
    }
    case constants.GET_CITIES.FULFILLED: {
      return { ...state, citylookUp: action.payload }
    }
    case constants.GET_USERS.FULFILLED: {
      const users = action.payload.data?.filter(el => el.user_name)

      return { ...state, ownerlookUp: users }
    }
    case constants.EDIT_PROPERTY_NAME.ACTION: {
      const { propertyType, name, isNameModified } = action.payload
      const { templateName, barChartSettings } = state
      const compsDataItems = [...state.compsData]

      compsDataItems.forEach(property => {
        if (property.propertyType === propertyType) {
          property.name = name
          // eslint-disable-next-line no-unused-expressions
          isNameModified
            ? (property.fieldsForOvSync = {
                ...property.fieldsForOvSync,
                isNameModified
              })
            : null
          property.propertyData.name = name
        }
      })

      const barChartData = getChartData(
        state.compsData,
        templateName,
        barChartSettings
      )
      let fpSummaryData = []
      let fpBarChartData = []
      if (
        templateName?.includes(RENT_COMPARABLES) ||
        templateName?.includes(SH_COMPARABLES)
      ) {
        fpSummaryData = getFpData(state.compsData)
        fpBarChartData = getFPBarChartData(fpSummaryData, barChartSettings)
      }

      return {
        ...state,
        compsData: [...state.compsData],
        barChartData: [...barChartData],
        fpSummaryData: [...fpSummaryData],
        fpBarChartData: [...fpBarChartData],
        resetflag: true,
        barChartSettings: { ...state.barChartSettings }
      }
    }
    case constants.GET_PROPERTY_INFO_BY_SOURCE.ACTION: {
      const propertySearchData = normalize.mappingPropertyDataToComps(
        state,
        action.payload.source
      )
      propertySearchData.isAddedFromSearch = true
      propertySearchData.propertyType =
        state.compsData[state.compsData.length - 2].propertyType + 1
      propertySearchData.propertyData.propertyType =
        state.compsData[state.compsData.length - 2].propertyType + 1

      state.compsData.splice(state.compsData.length - 1, 0, propertySearchData)
      const propertySummaryData = normalize.normalizePropertyDeleted(
        state,
        null
      )

      const { templateName, barChartSettings, fpSummaryTableColumns } = state
      const barChartData = getChartData(
        state.compsData,
        templateName,
        barChartSettings
      )
      let fpSummaryData = []
      let fpBarChartData = []
      if (
        templateName?.includes(RENT_COMPARABLES) ||
        templateName?.includes(SH_COMPARABLES)
      ) {
        fpSummaryData = getFpData(state.compsData)
        fpBarChartData = getFPBarChartData(fpSummaryData, barChartSettings)
      }

      for (const obj in fpSummaryData) {
        if (
          fpSummaryData[obj].type &&
          !fpSummaryTableColumns[fpSummaryData[obj].type]
        ) {
          fpSummaryTableColumns[obj.type] = FLOOR_PLAN_SUMMARY_TABLE_COLUMNS
        }
      }

      const compsDataaWithTruncate = setTruncatedFlag(
        propertySummaryData.updatedProperties,
        state.templateDataLimits,
        templateToggleSettings(state.toggleSettings)
      )

      return {
        ...state,
        status: 'property',
        compsData: [...compsDataaWithTruncate],
        barChartData: [...barChartData],
        fpSummaryData: [...fpSummaryData],
        fpBarChartData: [...fpBarChartData],
        fpSummaryTableColumns,
        resetflag: true,
        barChartSettings: { ...state.barChartSettings },
        isListRefreshed: false
      }
    }
    case constants.REFRESH_LIST_INFO.FULFILLED: {
      const selectTemplateType = state?.templateDataLimits?.key
      const templateDataLimitss = { ...setDataLimits(selectTemplateType) }

      // will create compsData object using OV list
      const compsDataCopy = normalize.createCompsDataFromOVList(
        action.payload?.listInfo,
        templateDataLimitss
      )
      const propAddedFromSearch = state.compsData?.filter(
        prop => prop?.isAddedFromSearch
      )

      // List refresh- All Properties
      if (action.payload?.resetAllProperties) {
        compsDataCopy.pop()
      } else {
        // add/delete properties
        compsDataCopy.pop()
        const commonProps = state?.compsData?.filter(sProp =>
          compsDataCopy.some(cProp => sProp.propertySFId === cProp.propertySFId)
        )
        if (commonProps.length > 0) {
          compsDataCopy.forEach((cdProp, i) => {
            commonProps.forEach(cpProp => {
              if (cdProp?.propertySFId === cpProp?.propertySFId) {
                // compsDataCopy[i] = { ...compsDataCopy[i], ...compsDataCopy[i].propertyData, ...cpProp, ...cpProp.propertyData }
                cpProp.propertyType = compsDataCopy[i].propertyType
                cpProp.propertyData.propertyType = compsDataCopy[i].propertyType
                compsDataCopy[i] = { ...cpProp }
                if (compsDataCopy[i].propertyType.toString().includes('S')) {
                  compsDataCopy[i].propertyAddress = null
                  compsDataCopy[i].propertyData.propertyAddress = 'NA'
                }
              }
            })
          })
        }
        if (propAddedFromSearch?.length > 0) {
          for (const prop of propAddedFromSearch) {
            if (
              !compsDataCopy.some(c => c.propertySFId === prop.propertySFId)
            ) {
              prop.propertyType =
                compsDataCopy[compsDataCopy.length - 1].propertyType + 1
              prop.propertyData.propertyType =
                compsDataCopy[compsDataCopy.length - 1].propertyType + 1
              compsDataCopy.push(prop)
            }
          }
        }
      }

      compsDataCopy.push({
        propertyType: 'NA',
        notes: 'NA',
        name: 'NA',
        comparableData: [],
        propertyData: {},
        chartData: {},
        mostRecentSaleDate: null,
        city: 'NA',
        propertyAddress: null,
        yearBuilt: null,
        yearRen: null,
        state: 'NA',
        occupancyAsOfDate: null
      })

      const propertySummaryData = normalize.normalizePropertyDeleted(
        { ...state, compsData: compsDataCopy },
        null
      )
      const updatedCompsData = [...propertySummaryData.updatedProperties]
      const compsDataWithTruncateCopy = setTruncatedFlag(
        updatedCompsData,
        state.templateDataLimits,
        state.toggleSettings
      )

      return {
        ...state,
        compsData: [...compsDataWithTruncateCopy],
        barChartData: propertySummaryData.barChartData,
        fpSummaryData: propertySummaryData.fpSummaryData,
        fpBarChartData: propertySummaryData.fpBarChartData,
        resetflag: true,
        isListRefreshed: true
      }
    }
    case constants.TOGGLE_PROPERTY_WEIGHTED_AVG.ACTION: {
      const { propertyType, hideUnitMixTotal } = action.payload
      const compsProperties = [...state.compsData]
      const selectedProperty = compsProperties.find(
        property => property.propertyType === propertyType
      )
      selectedProperty.hideUnitMixTotal = hideUnitMixTotal

      return { ...state, compsData: [...compsProperties] }
    }

    case constants.SET_TAB_INDEX.ACTION: {
      const { tabValue } = action.payload

      return { ...state, activeTabIndex: tabValue }
    }

    default:
      return state
  }
}
